import { useEffect } from "react";
import Lenis from "lenis";
import { CartProvider } from "@/context/CartContext";
import { setLenis } from "@/lib/scroll";
import Navbar from "@/components/iogama/Navbar";
import Hero from "@/components/iogama/Hero";
import Marquee from "@/components/iogama/Marquee";
import Manifesto from "@/components/iogama/Manifesto";
import Catalog from "@/components/iogama/Catalog";
import Leadership from "@/components/iogama/Leadership";
import Trust from "@/components/iogama/Trust";
import Footer from "@/components/iogama/Footer";
import OrderDrawer from "@/components/iogama/OrderDrawer";
import InquiryModal from "@/components/iogama/InquiryModal";

export default function Site() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <CartProvider>
      <div className="App grain" data-testid="iogama-app">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <Catalog />
          <Leadership />
          <Trust />
        </main>
        <Footer />
        <OrderDrawer />
        <InquiryModal />
      </div>
    </CartProvider>
  );
}
